import styled from "styled-components";

export const InputWrapper = styled.div`
  input[disabled] {
    color: #919eab !important;
  }
`;
